import { IsOptional } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class LotCodesRequest {
    @ApiProperty()
    saleOrderId: number;

    @ApiProperty()
    saleOrderItemId: number;

    @ApiProperty()
    plantId: number;
}
